const React = require("react");
function IconPdf(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 12",
    fill: props.fill || "#232323",
    height: props.size || 12,
    size: props.size || 24,
    width: 24 * (props.size * 100 / 12) / 100 || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.89474 0H22.1053C23.1517 0 24 .805887 24 1.8v8.4c0 .9941-.8483 1.8-1.8947 1.8H1.89474C.848303 12 0 11.1941 0 10.2V1.8C0 .805887.848303 0 1.89474 0m1.89473 8.90526h1.0099V7.05789h1.14126c1.26442 0 2.29895-.67326 2.29895-1.96231v-.01642c0-1.15769-.84568-1.92127-2.184-1.92127H3.78947zm1.0099-2.75873V4.07747h1.1741c.75537 0 1.23979.35306 1.23979 1.02632v.01642c0 .59937-.47621 1.02632-1.23979 1.02632zm4.47448 2.75873h2.14295c1.8063 0 3.0543-1.25621 3.0543-2.87368v-.01642c0-1.61748-1.248-2.85727-3.0543-2.85727H9.27385zm1.00985-.91958V4.07747h1.1331c1.2069 0 1.9952.82927 1.9952 1.95411V6.048c0 1.12484-.7883 1.93768-1.9952 1.93768zm6.4225.91958h-1.0099V3.15789h4.2777v.91958h-3.2678v1.56821h2.8984v.91958h-2.8984z",
    clipRule: "evenodd"
  }));
}
module.exports = IconPdf;